class CustomVideo extends HTMLElement {
    connectedCallback() {
        
        this.video = this.querySelector('video');
        this.video.addEventListener('click',this.toggle.bind(this));
        this.play = false;
    }
    toggle() {
       
        if(!this.play) {
            this.playVideo();
        }else {
            this.pauseVideo() 
        }
    }
    async playVideo() {
        this.classList.add('active');
        await this.video.play();
        this.play = true;
    }
    pauseVideo() {
        this.classList.remove('active');
        this.video.pause();
        this.play = false;
    }
}
customElements.define('custom-video', CustomVideo)